import { render, staticRenderFns } from "./ContractTemplateVariantsSection.vue?vue&type=template&id=0fc48976&scoped=true"
import script from "./ContractTemplateVariantsSection.vue?vue&type=script&lang=js"
export * from "./ContractTemplateVariantsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc48976",
  null
  
)

export default component.exports